import { IClassname } from '@/lib/shared/model/classname';

export const Jacuzzi = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.9999 12.9736H2.00049V16.0847H29.9999V12.9736Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.9633 16.084H3.03784V27.4912H28.9633V16.084Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6299 12.9733V11.4177C19.6299 9.98665 20.7913 8.8252 22.2224 8.8252C23.6535 8.8252 24.815 9.98665 24.815 11.4177V12.9733"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7407 12.9733V11.4177C22.7407 9.98665 23.9022 8.8252 25.3333 8.8252C26.7643 8.8252 27.9258 9.98665 27.9258 11.4177V12.9733"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.8523 25.417V27.491"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.7781 25.417V27.491"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="10" y="1.17578" width="2" height="2" rx="1" fill="#22364A" />
      <rect
        x="4"
        y="3.17578"
        width="4"
        height="3"
        rx="1.5"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="12"
        y="6.17578"
        width="2"
        height="3"
        rx="1"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="16" y="3.17578" width="2" height="2" rx="1" fill="#22364A" />
      <rect x="6" y="9.17578" width="2" height="2" rx="1" fill="#22364A" />
    </svg>
  );
};
